import React from 'react';
import { Box, Text, VStack, useBreakpointValue } from '@chakra-ui/react';
import { surveyTheme as theme } from './surveyTheme';

/**
 * LikertScale - Scale question (e.g., 5-point agree/disagree)
 *
 * Desktop: Horizontal row of buttons
 * Mobile: Vertical stacked buttons
 *
 * Props:
 *   question: { choices: [{id, text}] }
 *   selectedChoiceId: string
 *   onSelect: (choiceId) => void
 */
const LikertScale = ({ question, selectedChoiceId, onSelect, lang = 'en' }) => {
  const { choices = [] } = question;
  const loc = (en, es) => (lang === 'es' && es) ? es : en;

  return (
    <VStack spacing={2} align="stretch">
      {choices.map((choice) => {
        const isSelected = selectedChoiceId === String(choice.id);

        return (
          <Box
            key={choice.id}
            as="button"
            type="button"
            onClick={() => onSelect(choice.id)}
            width="100%"
            py={3}
            px={4}
            bg={isSelected ? theme.colors.teal : theme.colors.surface}
            color={isSelected ? 'white' : theme.colors.textSecondary}
            border="1.5px solid"
            borderColor={isSelected ? theme.colors.teal : theme.colors.borderLight}
            borderRadius="10px"
            cursor="pointer"
            transition={`all ${theme.transitions.fast}`}
            boxShadow={isSelected ? theme.shadows.selected : 'none'}
            _hover={{
              borderColor: theme.colors.teal,
              boxShadow: isSelected ? theme.shadows.selected : theme.shadows.subtle,
            }}
            _focus={{
              outline: 'none',
              boxShadow: `0 0 0 3px rgba(59, 107, 107, 0.3)`,
            }}
            _active={{ transform: 'scale(0.97)' }}
            textAlign="left"
            role="radio"
            aria-checked={isSelected}
          >
            <Text
              fontSize="15px"
              fontWeight={isSelected ? 600 : 450}
              lineHeight="1.3"
              fontFamily={theme.typography.fontFamily}
            >
              {loc(choice.text, choice.text_es)}
            </Text>
          </Box>
        );
      })}
    </VStack>
  );
};

export default LikertScale;
